import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import { BrandColors } from "../utils";

export const BrandInput = styled(TextField)({
  "& label.Mui-focused": {
    color: BrandColors.brandGreen,
  },
  '.MuiFilledInput-root:after': {
    borderBottomColor: BrandColors.brandGreen,
  },
  '.MuiFilledInput-root:before': {
    borderBottomColor: BrandColors.brandGreen,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: BrandColors.brandGreen,
    },
    "&:hover fieldset": {
      borderColor: BrandColors.brandGreen,
    },
    "&.Mui-focused fieldset": {
      borderColor: BrandColors.brandGreen,
    },
  },
});

export const BrandInputWhite = styled(TextField)({
  backgroundColor: '#fff',
  "& label.Mui-focused": {
    color: BrandColors.brandGreen,
  },
  '.MuiFilledInput-root:after': {
    borderBottomColor: BrandColors.brandGreen,
  },
  '.MuiFilledInput-root:before': {
    borderBottomColor: BrandColors.brandGreen,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: BrandColors.brandGreen,
    },
    "&:hover fieldset": {
      borderColor: BrandColors.brandGreen,
    },
    "&.Mui-focused fieldset": {
      borderColor: BrandColors.brandGreen,
    },
  },
});

